<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAiAssistant_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <g fill="currentColor" clip-path="url(#IconAiAssistant_24__a)">
        <path
            d="M7.714 18.025V9h1.524q.166 0 .333.037.168.038.334.088L16.5 11.7q.332.125.536.45.202.325.202.675 0 .525-.345.85t-.798.325h-2.5a1 1 0 0 1-.178-.012.6.6 0 0 1-.155-.063l-1.524-.625-.31.975 1.834.675q.048.026.143.038t.166.012h6.524q.762 0 1.334.575.57.574.571 1.425l-7.595 3zM2 20V9h3.81v11zM19.05 13q0-2.3 1.76-3.9t4.29-1.6q-2.53 0-4.29-1.6T19.05 2q0 2.3-1.76 3.9T13 7.5q2.53 0 4.29 1.6t1.76 3.9"
        />
    </g>
    <defs>
        <clipPath id="IconAiAssistant_24__a">
            <path fill="currentColor" d="M0 0h24v24H0z" />
        </clipPath>
    </defs>
</svg>
